export default {"src":"/_next/static/media/game_crash.5d6b1047.svg","height":155,"width":162,"blurWidth":0,"blurHeight":0};